export const COLOR_PALETTES = {
  DEFAULT: {
    highlightColor1: {
      background: '#FFF2B2',
      border: '#AD9100',
      hover: '#FFE566',
    },
    highlightColor2: {
      background: '#DEFFDD',
      border: '#03AD00',
      hover: '#BEFFBD',
    },
    highlightColor3: {
      background: '#FFE3C9',
      border: '#EB7100',
      hover: '#FFC793',
    },
    highlightColor4: {
      background: '#F0E1FF',
      border: '#B870FF',
      hover: '#E1C2FF',
    },
    selectionColor: { background: '#D8DEE4' },
    spotlightColor: { background: '#D8DEE4' },
  },
  HIGH_CONTRAST: {
    highlightColor1: {
      background: '#B99D13',
      border: '#8A7300',
      hover: '#998000',
    },
    highlightColor2: {
      background: '#0DB80A',
      border: '#028A00',
      hover: '#039900',
    },
    highlightColor3: {
      background: '#FC7B03',
      border: '#BD5B00',
      hover: '#D66800',
    },
    highlightColor4: {
      background: '#C285FF',
      border: '#9E3DFF',
      hover: '#A852FF',
    },
    selectionColor: { background: '#8B94B1' },
    spotlightColor: { background: '#8B94B1' },
  },
};

export const BUTTON_COLORS = {
  DEFAULT: {
    red: {
      background: '#FFD4DC',
      border: '#FF2943',
    },
    orange: {
      background: '#FFE3C9',
      border: '#EB7100',
    },
    gold: {
      background: '#FFF2B2',
      border: '#AD9100',
    },
    yellow: {
      background: '#FFF2B2',
      border: '#FFD81A',
    },
    lime: {
      background: '#DEFFDD',
      border: '#03AD00',
    },
    green: {
      background: '#D0F5E4',
      border: '#05A300',
    },
    blue: {
      background: '#F0E1FF',
      border: '#D1A3FF',
    },
    purple: {
      background: '#F0E1FF',
      border: '#B870FF',
    },
  },
  HIGH_CONTRAST: {
    red: {
      background: '#FFD4DC',
      border: '#FF2943',
    },
    orange: {
      background: '#FFE3C9',
      border: '#EB7100',
    },
    gold: {
      background: '#FFF2B2',
      border: '#AD9100',
    },
    yellow: {
      background: '#FFF2B2',
      border: '#AD9100',
    },
    lime: {
      background: '#DEFFDD',
      border: '#03AD00',
    },
    green: {
      background: '#D0F5E4',
      border: '#05A300',
    },
    blue: {
      background: '#F0E1FF',
      border: '#D1A3FF',
    },
    purple: {
      background: '#F0E1FF',
      border: '#B870FF',
    },
  },
};

export const COLOR_MAP = {
  yellow: 'highlightColor1',
  green: 'highlightColor2',
  red: 'highlightColor3',
  blue: 'highlightColor4',
};

export const COLOR_PALETTE_OPTIONS = {
  DEFAULT: 'DEFAULT',
  HIGH_CONTRAST: 'HIGH_CONTRAST',
};

export const DEFAULT_COLOR = 'yellow';
